import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as Bg } from "images/svg/blogEllipse.svg";
import TextInput from "components/inputs/text-input";
import PrimaryButton from "components/buttons/primary-button";

const Header = () => {
  return (
    <Container>
      <Typography
        color={Colors.yellow500}
        size="lg"
        align="center"
        weight="semibold"
        mb="1.2"
        m_size="m"
      >
        Our Blog
      </Typography>
      <Typography
        size="4.8rem"
        align="center"
        weight="bold"
        mb="2.4"
        m_size="3.6rem"
      >
        The Rated Afrika Blog
      </Typography>
      <Typography
        size="xl"
        m_size="m"
        color={Colors.grey400}
        lh="2.8rem"
        m_lh="2.4rem"
        align="center"
      >
        Subscribe to learn about what’s going on in the music industry, music
        tips, and updates.
      </Typography>
      <InputButtonGroup>
        <TextInput placeholder="Enter your email" />
        <PrimaryButton text="Subscribe" />
      </InputButtonGroup>
      <Typography mt="1" color={Colors.grey400}>
        We care about your data in our privacy policy
      </Typography>

      <Background>
        <Bg />
      </Background>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  padding: 9.6rem 14rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 769px) {
    padding: 4.8rem 3rem;
  }
`;

const Background = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const InputButtonGroup = styled.div`
  display: grid;
  margin-top: 4rem;
  grid-template-columns: 36rem 13.5rem;
  grid-column-gap: 1.6rem;
  @media only screen and (max-width: 769px) {
    width: 100%;
    grid-template-columns: 100%;
    grid-row-gap: 1.6rem;
  }
`;
